import { render, staticRenderFns } from "./CategoriesCards.vue?vue&type=template&id=5db82a8c&scoped=true&"
import script from "./CategoriesCards.vue?vue&type=script&lang=js&"
export * from "./CategoriesCards.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesCards.vue?vue&type=style&index=0&id=5db82a8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db82a8c",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard, BCardGroup} from 'bootstrap-vue'
    installComponents(component, {BCard, BCardGroup})
    

export default component.exports